import useResources from "./use-resources";

export default function useRepartitionKeys(propertyFolderId) {
  const ROOT_PATH = `property-folders/${propertyFolderId}/repartition-keys`;
  const {
    resources: repartitionKeys,
    error,
    isLoading,
    update,
    del,
    create,
    mutate,
  } = useResources(propertyFolderId ? `${ROOT_PATH}` : null, {}, {});

  return {
    repartitionKeys,
    error,
    isLoading,
    createKey: create,
    updateKey: update,
    deleteKey: del,
    mutate,
  };
}
